import { useEffect, useState } from "react";
import OfferItem from "../offer-item/OfferItem.component";
import {
  CampaignType,
  Offer,
  OffersIdSlots,
  Template,
} from "../../../../types/global.types";
import { TemplateOptionSettings } from "../../../../types/global.types";

interface Props {
  sessionId: string;
  displayOnly: boolean;
  settings: TemplateOptionSettings;
  campaign: CampaignType;
  offersCount: string;
  offers: Offer[];
  settingsTemplate: Template;
  campaignId: string;
  placementId: string;
  placementName: string;
  isInline?: boolean;
  isSeen: boolean;
  preEmail: string | undefined;
  setPreEmail?: (email: string) => void;
  openSingle: (
    o: Offer,
    isSave: boolean,
    isAutoEmail: boolean,
    slot: number
  ) => void;
  onAdd: (offer: Offer, value: boolean, slot: number) => void;
  layoutId: string;
  canAutoSendEmailFromLabel: boolean;
  canAutoSendEmailFromMainCTA: boolean;
  onAutoSendEmailFromLabel: (offer: Offer, slot: number) => Promise<void>;
  autoSendingOfferId: string;
}

const GridOffers = ({
  sessionId,
  isSeen,
  settings,
  preEmail,
  setPreEmail,
  campaign,
  offers,
  displayOnly,
  campaignId,
  placementId,
  placementName,
  settingsTemplate,
  openSingle,
  onAdd,
  layoutId,
  canAutoSendEmailFromLabel,
  canAutoSendEmailFromMainCTA,
  onAutoSendEmailFromLabel,
  autoSendingOfferId,
}: Props) => {
  const [eventOfferIds, setEventOfferIds] = useState<OffersIdSlots[]>([]);

  useEffect(() => {
    if (isSeen) {
      const _ids = offers.map((offer: Offer, index: number) => ({
        id: offer.id,
        slot: index + 1,
      }));
      setEventOfferIds(_ids);
    }
    // eslint-disable-next-line
  }, [isSeen]);

  return (
    <div
      className="grid-wrapper grid"
      id="grid-container"
      style={{
        gridTemplateColumns:
          settings.mainLayout.offersNumber === "auto"
            ? "repeat(auto-fill, minmax(250px, 300px))"
            : `repeat(${settings.mainLayout.offersNumber}, 1fr)`,
        justifyContent: settings.mainLayout.align,
      }}
    >
      {offers?.map((o: Offer, i: number) => {
        return (
          <OfferItem
            sessionId={sessionId}
            key={o.id}
            offer={o}
            slot={i + 1}
            eventOfferIds={eventOfferIds}
            settings={settings}
            isAdded={o.isAdded || false}
            settingsTemplate={settingsTemplate}
            onAdd={onAdd}
            displayOnly={displayOnly}
            campaign={campaign}
            retailerId={campaign?.company_Id}
            campaignId={campaignId}
            placementId={placementId}
            placementName={placementName}
            openSingle={openSingle}
            setPreEmail={setPreEmail}
            preEmail={preEmail}
            hasVoucher={offers.some(
              (offer) => offer.voucher && offer.voucher.voucherType
            )}
            otherSettings={settings.otherSettings}
            layoutId={layoutId}
            layoutOptions={settings.layoutOptions}
            canAutoSendEmailFromLabel={canAutoSendEmailFromLabel}
            canAutoSendEmailFromMainCTA={canAutoSendEmailFromMainCTA}
            onAutoSendEmailFromLabel={onAutoSendEmailFromLabel}
            autoSendingOfferId={autoSendingOfferId === o.id}
          />
        );
      })}
    </div>
  );
};

export default GridOffers;
